/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Domain_SettingsInputs */



/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Perm_Domain_SettingsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_domain_settings = /** @type {((inputs?: Perm_Domain_SettingsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Domain_SettingsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки")
	return /** @type {LocalizedString} */ ("Settings")
});